import { FontAwesomeIcon } from "@nef/core"

import { MarketHoliday } from "../../types/MarketHoliday"
import { dateFormatForDisplay } from "../../utils/datetimehandler"
import { ApplicationTypeDescriptionEnum, InstrumentStatusDescriptionEnum } from "../../types/_enums"
import CustomTableFilter from "../../components/common/CustomTableFilter"
import { sortColumn } from "../../utils/common"
import { TABLE_FILTER_BOOLEAN_FDROPDOWN } from "../common"

const marketHolidayColumns = (isCustom: boolean, onDeleteClick: Function = () => {}) => {
  const columns = [
    {
      Header: "Holiday Name",
      accessor: (data: MarketHoliday) => {
        return data.reason || "-"
      }
    },
    {
      Header: "Date",
      accessor: (data: MarketHoliday) => {
        return dateFormatForDisplay(data.calendarDate)
      }
    },
    {
      Header: "Scope",
      accessor: (data: MarketHoliday) => {
        return data.country || "Global"
      }
    }
  ]
  return isCustom
    ? [
        {
          Header: "Delete",
          width: "60",
          Cell: ({ cell }: any) => {
            const { original } = cell.row
            return (
              <FontAwesomeIcon
                style={{ fontSize: "14px", cursor: "pointer", color: "crimson" }}
                iconSetClassName="fas"
                iconClassName="fa-trash"
                onClick={() => onDeleteClick(original)}
                data-testid="delBtn"
              />
            )
          }
        },
        ...columns
      ]
    : columns
}

export default marketHolidayColumns

export const calendarInstrumentColumns = () => {
  return [
    {
      Header: "Status",
      id: "status",
      width: "150",
      accessor: (data: any) => {
        return InstrumentStatusDescriptionEnum[data.status as keyof typeof InstrumentStatusDescriptionEnum] || "-"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "status", customLabelList: InstrumentStatusDescriptionEnum})
    },

    {
      Header: "Symbol",
      id: "symbol",
      width: "100",
      accessor: (data: any) => {
        return data.symbol || "-"
      }
    },
    {
      Header: "Application Type",
      id: "applicationType",
      width: "200",
      accessor: (data: any) => {
        return ApplicationTypeDescriptionEnum[data.applicationType as keyof typeof ApplicationTypeDescriptionEnum] || "-"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "applicationType", customLabelList: ApplicationTypeDescriptionEnum})
    },
    {
      Header: "CUSIP",
      id: "cusip",
      width: "100",
      accessor: (data: any) => {
        return data.cusip || "-"
      }
    },
    {
      Header: "ISIN",
      id: "isin",
      width: "120",
      accessor: (data: any) => {
        return data.isin || "-"
      }
    },
    {
      Header: "Nasdaq Security Master",
      id: "nsm",
      width: "180",
      accessor: (data: any) => {
        return data.nsm || "-"
      }
    },
    {
      Header: "Issuer Name",
      id: "issuerName",
      width: "200",
      accessor: (data: any) => {
        return data.issuerName || "-"
      }
    },
    {
      Header: "Issuer ID",
      id: "issuerId",
      width: "100",
      accessor: (data: any) => {
        return data.issuerId || "-"
      }
    },
    {
      Header: "Instrument Name",
      id: "instrumentName",
      width: "200",
      accessor: (data: any) => {
        return data.instrumentName || "-"
      }
    },
    {
      Header: "Product Symbol",
      id: "productSymbol",
      width: "130",
      accessor: (data: any) => {
        return data.productSymbol || "-"
      }
    },
    {
      Header: "Pricing Agent",
      id: "pricingAgent",
      width: "200",
      accessor: (data: any) => {
        return data.pricingAgent || "-"
      }
    },
    {
      Header: "Instrument Type",
      id: "instrumentType",
      width: "200",
      accessor: (data: any) => {
        return data.instrumentType || "-"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "instrumentType"})
    },
    {
      Header: "Instrument Code",
      id: "instrumentCategory",
      width: "200",
      accessor: (data: any) => {
        return data.instrumentCategory || "-"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "instrumentCategory"})
    },
    {
      Header: "Model Portfolio",
      id: "modelPortfolio",
      width: "130",
      accessor: (data: any) => {
        return data.modelPortfolio ? "Yes" : "No"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "modelPortfolio", customOptions : TABLE_FILTER_BOOLEAN_FDROPDOWN})
    },
    {
      Header: "529",
      id: "is529",
      width: "120",
      accessor: (data: any) => {
        return data.is529 ? "Yes" : "No"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "is529", customOptions : TABLE_FILTER_BOOLEAN_FDROPDOWN})
    },
    {
      Header: "Suggested Price",
      id: "suggestedPrice",
      width: "130",
      accessor: (data: any) => {
        return data.suggestedPrice || "- "
      }
    },
    {
      Header: "System Effective Date",
      id: "effectiveDate",
      width: "160",
      sortType: (rowA: any, rowB: any) => sortColumn(rowA, rowB, "effectiveDate"),
      accessor: (data: any) => {
        return dateFormatForDisplay(data.effectiveDate)
      }
    },
    {
      Header: "Excluded From Distribution",
      id: "excludeFromDistribution",
      width: "200",
      accessor: (data: any) => {
        return data.excludeFromDistribution ? "Yes" : "No"
      },
      Filter : ({column, data} : any) => CustomTableFilter({column, data, fieldName: "excludeFromDistribution", customOptions : TABLE_FILTER_BOOLEAN_FDROPDOWN})
    }
  ]
  
}